import { getCurrentInstance } from 'vue'

export function useDateFormat(date: Date): string {
  const ctx = getCurrentInstance()
  if (!ctx) {
    throw new Error("'ctx' is not defined")
  }
  const {
    proxy: { $epb },
  } = ctx

  return formatDate(date, $epb.locale)
}

function formatDate(date: Date, locale: Intl.LocalesArgument): string {
  const options: any = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }
  return date.toLocaleString(locale, options)
}
